<app-card>
  <ng-container cardBody>

    <div class="d-flex w-100 align-items-center justify-content-center flex-column scanner-components">
      <app-validate-scanner-ui-input [brandId]="brandId"
                                     [isValidateView]="true"></app-validate-scanner-ui-input>
      <h1 class="mt-10">Silahkan validasi QR </h1>
    </div>

  </ng-container>
</app-card>
<br>
<app-info-products
  [id]="brandId" [readDetail]="false"></app-info-products>

<div class="w-100 d-flex justify-content-end mt-10">
  <button (click)="backBtnClick()" class="btn btn-primary min-w-150px">
    Kembali
  </button>
</div>
